import { ReactNode } from 'react';
import classNames from 'classnames';
import { RadioContextProvider } from '../RadioContext';
import styles from './styles.module.scss';

export interface IRadioGroupProps {
  children: ReactNode;
  label: string;
  name: string;
  onChange?: (value: string) => void;
  value?: string;
  className?: string;
}

const RadioGroup = ({ children, label, name, value, onChange, className }: IRadioGroupProps) => {
  return (
    <RadioContextProvider value={{ name, selectedValue: value, setSelectedValue: onChange }}>
      <div className={classNames(styles.container, className)} role='radiogroup'>
        <span className={styles.label}>{label}</span>
        <div className={styles.options}>{children}</div>
      </div>
    </RadioContextProvider>
  );
};

export default RadioGroup;
